import styled from 'styled-components';

export const AuthenticationTabStyle = styled('div')`
  .ql-container {
    height: 500px;
  }

  .ant-btn {
    margin-top: 16px;
  }
`;
